import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MediaImageModal from './MediaImageModal';
import MediaVideoModal from './MediaVideoModal';
import axios from 'axios';
import PageLoadingSpinner from '../FullPageLoader';
import profile from '../../assets/profile.jpg';
import ReactDragListView from 'react-drag-listview';
import VideoProcessing from "../../assets/video-processing.jpg";

/*import './mediacomponent.css';*/


function MediaDisplay({ imageId, imageSrc, imageAlt, children }) {
    return (
        <div className="galleryItem node-selector select-handler videoThumbWrap" data-element="galleryItem" data-id={imageId}>
            <img className="galleryImage" src={imageSrc} alt={imageAlt} />
            {children}
        </div>
    )
}
MediaDisplay.propTypes = {
    imageId: PropTypes.number,
    imageSrc: PropTypes.string,
    imageAlt: PropTypes.string,
    children: PropTypes.node
}

function MediaGallery({ mediaItems, onMediaDelete, onMediaEdit, isPlaceHolder, allowSorting, sortInTable, saveMediaItems }) {

    const handleEditItem = (e) => {
        let itemId = e.target.closest('[data-element="galleryItem"]').dataset.id;
        onMediaEdit(itemId);
    }

    const handleDeleteMedia = (e) => {
        let itemId = e.target.closest('[data-element="galleryItem"]').dataset.id;
        if (itemId !== undefined && itemId != null)
            onMediaDelete(itemId);
    }

    const [sortedMediaItems, setSortedMediaItems] = useState({});

    useEffect(() => {
        setSortedMediaItems(mediaItems);
    }, [mediaItems]);

    if (mediaItems.length > 0) {
        return (
            <>
                {(allowSorting === true) ?
                    <ReactDragListView
                        nodeSelector='.node-selector'
                        handleSelector='.select-handler'
                        allowDragAndDrop={true}
                        onDragEnd={(fromIndex, toIndex) => {
                            const updatedItems = [...sortedMediaItems];
                            const [draggedItem] = updatedItems.splice(fromIndex, 1);
                            updatedItems.splice(toIndex, 0, draggedItem);
                            setSortedMediaItems(updatedItems);
                            console.log(sortInTable);
                            saveMediaItems(updatedItems);
                        }}>
                        <div className="mediaGallery">
                            {sortedMediaItems.map((item, idx) =>
                                <MediaDisplay
                                    key={'mediaItem_' + idx}
                                    imageId={item.id}
                                    imageSrc={item?.videoCustomThumbnailUrl ? item.videoCustomThumbnailUrl : item?.previewsrc && item?.previewsrc == '/images/video-processing.jpg' ? VideoProcessing : item?.previewsrc}
                                    imageAlt={item.altText}
                                >
                                    <div className="media-thumbnail-action-wrap">
                                        {/* Hiding edit for now until we get logic for it in place. User can always delete and add item */}

                                        <button className="media-thumbnail-action red margin-bt-edit-image"
                                            onClick={handleEditItem}
                                        >
                                            <span className="material-symbols-rounded">edit</span>
                                        </button>
                                        <button className="media-thumbnail-action red"
                                            onClick={handleDeleteMedia}
                                        >
                                            <span className="material-symbols-rounded">delete</span>
                                        </button>
                                    </div>
                                </MediaDisplay>
                            )}
                        </div>
                    </ReactDragListView>
                    :
                    <div className="mediaGallery">
                        {mediaItems.map((item, idx) =>
                            <MediaDisplay
                                key={'mediaItem_' + idx}
                                imageId={item.id}
                                imageSrc={item?.videoCustomThumbnailUrl ? item.videoCustomThumbnailUrl : item?.previewsrc && item?.previewsrc == '/images/video-processing.jpg' ? VideoProcessing : item?.previewsrc}
                                imageAlt={item.altText}
                            >
                                <div className="media-thumbnail-action-wrap">
                                    {/* Hiding edit for now until we get logic for it in place. User can always delete and add item */}

                                    <button className="media-thumbnail-action red margin-bt-edit-image"
                                        onClick={handleEditItem}
                                    >
                                        <span className="material-symbols-rounded">edit</span>
                                    </button>
                                    <button className="media-thumbnail-action red"
                                        onClick={handleDeleteMedia}
                                    >
                                        <span className="material-symbols-rounded">delete</span>
                                    </button>
                                </div>
                            </MediaDisplay>
                        )}
                    </div>
                }
            </>
        )
    }
    else {
        return (
            isPlaceHolder ? <img className="galleryImage" src={profile} alt='profileImage' /> : null
        )
    }
}
MediaGallery.propTypes = {
    mediaItems: PropTypes.array,
    onMediaDelete: PropTypes.func,
    onMediaEdit: PropTypes.func,
    isPlaceHolder: PropTypes.bool,
    allowSorting: PropTypes.bool,
    sortInTable: PropTypes.string,
    saveMediaItems: PropTypes.func
}

export default function MediaUploader({
    forceCrop, allowGallery, imageOnly, videoOnly, requireAltText,
    mediaItems, saveMediaItems, customImageSave, isPlaceHolder, allowSorting, sortInTable, width, higth, validationOnVideoUpload }) {

    const [showImageModal, setShowImageModal] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [ogImageSrc, setOgImageSrc] = useState(null);
    const [editImageObj, setEditImageObj] = useState(null);
    const [mediaLibrary, setLibrary] = useState(mediaItems ?? []);
    const [showSaving, setShowSaving] = useState(false);

    const handleSaveMedia = async (mediaObj) => {
        setShowSaving(true);
        axios({
            url: '/api/media/add',
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: mediaObj
        })
            .then((result) => {               
                let newMediaItem = {
                    id: result?.data?.data?.id,
                    altText: result?.data?.data?.altText && result?.data?.data?.altText.trim() !== "" ? result?.data?.data?.altText : result?.data?.data?.photo?.originalFileName,
                    previewsrc: result?.data?.previewsrc,
                    mediaId: result?.data?.data.id,
                    photo: result?.data?.data?.photo,
                    cropValues: result?.data?.data?.cropValues,
                    videoThumbnailUrl: result?.data?.data?.videoThumbnailUrl,
                    videoSrc: result?.data?.data?.videoSrc,
                    type: result?.data?.data?.type,
                    isCropped: result?.data?.data?.isCropped,
                    photoId: result?.data?.data?.photoId,
                    videoId: result?.data?.data?.videoId,
                    videoType: result?.data?.data?.videoType,
                    isVideoThumbnail: false,
                    cropPhoto: result?.data?.data?.cropPhoto,
                    cropPhotoId: result?.data?.data?.cropPhotoId,
                    videoCustomThumbnailUrl: (result?.data?.data?.photoId && result?.data?.data?.videoSrc ? result?.data?.previewsrc : ''),
                    selectedVideoSrc: result?.data?.data?.selectedVideoSrc,
                    vimeoVideoFileName: result?.data?.data?.vimeoVideoFileName
                    
                }
                setOgImageSrc(null);
                setShowImageModal(false);
                setShowVideoModal(false);
                // if you want to remove image and add new use this code
                //if (mediaObj != null && mediaObj?.id > 0) {
                //    const enityIndex = mediaLibrary.findIndex(x => x.id === mediaObj.id);
                //    if (enityIndex > -1) {
                //        mediaLibrary.splice(enityIndex, 1);
                //    }
                //}
                //setLibrary([...mediaLibrary, newMediaItem]);

                // if you want to replace if find use this code
                if (mediaObj != null && mediaObj.id > 0) {
                    // Find the index of the existing media item with the same id
                    const entityIndex = mediaLibrary.findIndex(x => x.id === mediaObj.id);

                    if (entityIndex > -1) {
                        // If the existing media item is found, remove it using splice

                        mediaLibrary.splice(entityIndex, 1);


                        // Add the new media item at the same index
                        mediaLibrary.splice(entityIndex, 0, newMediaItem);

                        saveMediaItems([...mediaLibrary]);

                    } else {
                        // If the existing media item is not found, simply add the new media item
                        setLibrary([...mediaLibrary, newMediaItem]);
                        saveMediaItems([...mediaLibrary, newMediaItem]);
                    }
                } else {
                    // Handle the case where mediaObj is null or id is not greater than 0
                    // Add the new media item to the library without removing any existing item
                    setLibrary([...mediaLibrary, newMediaItem]);
                    saveMediaItems([...mediaLibrary, newMediaItem]);
                }



                setShowSaving(false);
            })
            .catch((error) => {
                setShowSaving(false);
                alert(error);
            });
    }


    const handleMediaDelete = (mediaId) => {
        setLibrary(mediaLibrary.filter(x => x.id != mediaId));
        saveMediaItems(mediaLibrary.filter(x => x.id != mediaId));
    }
    const handleMediaEdit = (mediaId) => {
        let mediaObj = mediaLibrary.filter(x => x.id == mediaId)[0];
        setEditImageObj(mediaObj);
        if (mediaObj && mediaObj.type === 0) {
            setShowImageModal(true);
        }
        if (mediaObj && mediaObj.type === 1) {
            setShowVideoModal(true);
        }
    }
    useEffect(() => {
        setLibrary(mediaItems);
    }, [mediaItems]);

    const handleVideo = () => {
        if (showImageModal) setShowImageModal(false);
        if (typeof validationOnVideoUpload !== 'undefined') {
            if (validationOnVideoUpload()) {
                setShowVideoModal(true);
            }
        } else {           
            setShowVideoModal(true);
        }
        setEditImageObj(null)
    }

    return (
        <>
            <MediaGallery
                mediaItems={mediaLibrary}
                onMediaDelete={handleMediaDelete}
                onMediaEdit={handleMediaEdit}
                isPlaceHolder={isPlaceHolder}
                allowSorting={allowSorting}
                sortInTable={sortInTable}
                saveMediaItems={saveMediaItems}
            />
            {(!allowGallery && mediaLibrary.length > 0) ? null : (
                <div className="mediaOptions">
                    {(imageOnly || !videoOnly) ? (
                        <>
                            <label className="mediaAddImage">
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        setShowImageModal(true);
                                        setOgImageSrc(e.target.files[0])
                                    }} />
                                <svg className="photo-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="47" viewBox="0 0 48 47" fill="none">
                                    <g opacity="0.75">
                                        <mask id="mask0_14926_3956" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="47">
                                            <rect x="0.5" width="47" height="47" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_14926_3956)">
                                            <path d="M11.4957 39.1668C10.5942 39.1668 9.84158 38.8649 9.23776 38.2611C8.63394 37.6573 8.33203 36.9046 8.33203 36.0031V10.9972C8.33203 10.0957 8.63394 9.34304 9.23776 8.73923C9.84158 8.13541 10.5942 7.8335 11.4957 7.8335H24.2249C24.5023 7.8335 24.7349 7.9275 24.9225 8.1155C25.1102 8.3035 25.2041 8.53638 25.2041 8.81413C25.2041 9.09189 25.1102 9.32428 24.9225 9.5113C24.7349 9.69832 24.5023 9.79183 24.2249 9.79183H11.4957C11.1442 9.79183 10.8553 9.90476 10.6292 10.1306C10.4033 10.3568 10.2904 10.6457 10.2904 10.9972V36.0031C10.2904 36.3547 10.4033 36.6435 10.6292 36.8697C10.8553 37.0956 11.1442 37.2085 11.4957 37.2085H36.5017C36.8532 37.2085 37.1421 37.0956 37.3682 36.8697C37.5941 36.6435 37.707 36.3547 37.707 36.0031V23.274C37.707 22.9965 37.801 22.764 37.989 22.5763C38.177 22.3886 38.4099 22.2948 38.6877 22.2948C38.9654 22.2948 39.1978 22.3886 39.3848 22.5763C39.5719 22.764 39.6654 22.9965 39.6654 23.274V36.0031C39.6654 36.9046 39.3635 37.6573 38.7596 38.2611C38.1558 38.8649 37.4032 39.1668 36.5017 39.1668H11.4957ZM13.7551 32.0865H34.2422L27.9154 23.651L22.0404 31.0701L18.1237 26.3623L13.7551 32.0865ZM33.7904 13.7085H30.8529C30.5754 13.7085 30.3429 13.6145 30.1552 13.4265C29.9675 13.2385 29.8737 13.0056 29.8737 12.7279C29.8737 12.4501 29.9675 12.2177 30.1552 12.0307C30.3429 11.8437 30.5754 11.7502 30.8529 11.7502H33.7904V8.81266C33.7904 8.53523 33.8844 8.30268 34.0724 8.11501C34.2604 7.92733 34.4932 7.8335 34.771 7.8335C35.0488 7.8335 35.2811 7.92733 35.4682 8.11501C35.6552 8.30268 35.7487 8.53523 35.7487 8.81266V11.7502H38.6862C38.9636 11.7502 39.1962 11.8442 39.3839 12.0322C39.5715 12.2202 39.6654 12.453 39.6654 12.7308C39.6654 13.0086 39.5715 13.2409 39.3839 13.428C39.1962 13.615 38.9636 13.7085 38.6862 13.7085H35.7487V16.646C35.7487 16.9234 35.6547 17.156 35.4667 17.3437C35.2787 17.5313 35.0458 17.6252 34.7681 17.6252C34.4903 17.6252 34.2579 17.5313 34.0709 17.3437C33.8839 17.156 33.7904 16.9234 33.7904 16.646V13.7085Z" fill="#2A2A2A" />
                                        </g>
                                    </g>
                                </svg>
                                <span className="mediaAdd-button">Upload Image</span>
                                <span className="mediaAddPhotos">Add Photos</span>
                                {/*<div className="image-info">*/}
                                {/*    ideal image size :<br />*/}
                                {/*    {idealSizeText}*/}
                                {/*</div>*/}

                            </label>

                        </>
                    ) : (<></>)}
                    {(videoOnly || !imageOnly) ? (
                        <button
                            className="mediaAddVideo"
                            onClick={() => handleVideo()}
                        >
                            <svg className="video-icon" xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
                                <g opacity="0.75">
                                    <mask id="mask0_14926_3959" maskUnits="userSpaceOnUse" x="0" y="0" width="47" height="47">
                                        <rect width="47" height="47" fill="#d9d9d9" />
                                    </mask>
                                    <g mask="url(#mask0_14926_3959)">
                                        <path d="M9.98009 37.2084C9.07861 37.2084 8.32595 36.9065 7.72214 36.3027C7.11832 35.6989 6.81641 34.9462 6.81641 34.0447V25.2322C6.81641 24.9548 6.91041 24.7222 7.09841 24.5346C7.28641 24.3469 7.51928 24.2531 7.79704 24.2531C8.0748 24.2531 8.30719 24.3469 8.49421 24.5346C8.68123 24.7222 8.77474 24.9548 8.77474 25.2322V34.0447C8.77474 34.3962 8.88767 34.6851 9.11353 34.9113C9.33972 35.1372 9.62857 35.2501 9.98009 35.2501H31.0699C31.4211 35.2501 31.7098 35.1372 31.9359 34.9113C32.1618 34.6851 32.2747 34.3962 32.2747 34.0447V12.9554C32.2747 12.6039 32.1618 12.3151 31.9359 12.0889C31.7098 11.863 31.4211 11.7501 31.0699 11.7501H22.2574C21.9799 11.7501 21.7474 11.6561 21.5597 11.4681C21.372 11.2801 21.2782 11.0472 21.2782 10.7694C21.2782 10.4917 21.372 10.2593 21.5597 10.0723C21.7474 9.88526 21.9799 9.79175 22.2574 9.79175H31.0699C31.971 9.79175 32.7235 10.0937 33.3273 10.6975C33.9312 11.3013 34.2331 12.0539 34.2331 12.9554V22.069L38.8317 17.4704C39.0752 17.2269 39.3613 17.1685 39.69 17.2951C40.019 17.4217 40.1835 17.6623 40.1835 18.0167V28.9834C40.1835 29.3379 40.019 29.5784 39.69 29.7051C39.3613 29.8317 39.0752 29.7733 38.8317 29.5298L34.2331 24.9311V34.0447C34.2331 34.9462 33.9312 35.6989 33.3273 36.3027C32.7235 36.9065 31.971 37.2084 31.0699 37.2084H9.98009ZM14.9773 26.9458L13.0003 29.5406C12.7895 29.817 12.7599 30.0971 12.9117 30.3807C13.0635 30.6643 13.2913 30.8061 13.5952 30.8061H27.4543C27.7582 30.8061 27.986 30.6643 28.1378 30.3807C28.2895 30.0971 28.2726 29.817 28.0868 29.5406L24.2862 24.4567C24.126 24.2433 23.9203 24.1365 23.6693 24.1365C23.4183 24.1365 23.2075 24.242 23.0368 24.4528L18.7172 29.9024L16.2051 26.9086C16.0344 26.7225 15.8298 26.6295 15.5912 26.6295C15.3526 26.6295 15.148 26.7349 14.9773 26.9458ZM10.7331 15.6667H7.79557C7.51814 15.6667 7.28559 15.5727 7.09792 15.3847C6.91024 15.1967 6.81641 14.9639 6.81641 14.6861C6.81641 14.4084 6.91024 14.176 7.09792 13.9889C7.28559 13.8019 7.51814 13.7084 7.79557 13.7084H10.7331V10.7709C10.7331 10.4935 10.8271 10.2609 11.0151 10.0733C11.2031 9.88558 11.436 9.79175 11.7137 9.79175C11.9915 9.79175 12.2239 9.88558 12.4109 10.0733C12.5979 10.2609 12.6914 10.4935 12.6914 10.7709V13.7084H15.6289C15.9063 13.7084 16.1389 13.8024 16.3266 13.9904C16.5142 14.1784 16.6081 14.4113 16.6081 14.6891C16.6081 14.9668 16.5142 15.1992 16.3266 15.3862C16.1389 15.5732 15.9063 15.6667 15.6289 15.6667H12.6914V18.6042C12.6914 18.8817 12.5974 19.1142 12.4094 19.3019C12.2217 19.4896 11.9889 19.5834 11.7108 19.5834C11.433 19.5834 11.2006 19.4896 11.0136 19.3019C10.8266 19.1142 10.7331 18.8817 10.7331 18.6042V15.6667Z" fill="#2A2A2A" />
                                    </g>
                                </g>
                            </svg>
                            <span className="mediaAdd-button">Add Video</span>
                            <span className="mediaAddVideos">Add Video</span>
                        </button>
                    ) : (<></>)}
                </div>
            )}
            <MediaVideoModal
                requireAltText={requireAltText}
                showModal={showVideoModal}
                editVideoObj={editImageObj}
                onCloseModal={() => {
                    setEditImageObj(null);
                    setShowVideoModal(false);
                }}
                onSaveModal={handleSaveMedia}
                onMediaDelete={handleMediaDelete}
            />
            <MediaImageModal
                requireAltText={requireAltText}
                showModal={showImageModal}
                forceCrop={forceCrop}
                uploadImageObj={ogImageSrc}
                editImageObj={editImageObj}
                onCloseModal={() => {
                    setShowImageModal(false);
                    setEditImageObj(null);
                }}
                onSaveModal={handleSaveMedia}
                onCustomImageSave={customImageSave}
                cropWidth={width}
                cropHeight={higth}
            />
            <PageLoadingSpinner show={showSaving} />
        </>
    );
}

MediaUploader.propTypes = {
    forceCrop: PropTypes.bool,
    imageOnly: PropTypes.bool,
    videoOnly: PropTypes.bool,
    requireAltText: PropTypes.bool,
    allowGallery: PropTypes.bool,
    mediaItems: PropTypes.array,
    saveMediaItems: PropTypes.func,
    customImageSave: PropTypes.func,
    isPlaceHolder: PropTypes.bool,
    allowSorting: PropTypes.bool,
    sortInTable: PropTypes.string,
    idealSizeText: PropTypes.string,
    width: PropTypes.number,
    higth: PropTypes.number,
    validationOnVideoUpload: PropTypes.func
}

MediaUploader.defaultProps = {
    forceCrop: true,
    imageOnly: false,
    videoOnly: false,
    requireAltText: false,
    allowGallery: true,
    mediaItems: [],
    saveMediaItems: null,
    customImageSave: null,
    allowSorting: false,
    sortInTable: null,
    idealSizeText: '750px x 630px', 

}
